export default __webpack_public_path__ + "assets/img/student.19e4f7548effba749a15f75b2cd5cbf8.svg";